




















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import SpaAboutCaratDialog from '@spa/components/organisms/dialog/AboutCaratDialog.vue'
import UserInfoMobile from '@spa/components/organisms/mypage/user-info/UserInfoBase.vue'
import UserInfoPc from '@spa/components/organisms/mypage/user-info/UserInfoPc.vue'

@Component({
  components: {
    UserInfoMobile,
    UserInfoPc,
    SpaAboutCaratDialog,
  },
})
export default class UserInfo extends Vue {
  @Prop({ required: true })
  carat: string

  showModalAbout = false
}
